const wrapper = "_35swd6rtm1";

export { wrapper };
import "./_freetext.style.linaria.module.css";
//# sourceMappingURL=_freetext.style.js.map
